import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = {
  key: 0,
  class: "modal__header"
}
const _hoisted_3 = { class: "modal__header-title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_5 = { class: "modal__body" }
const _hoisted_6 = {
  key: 1,
  class: "modal__footer"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
    _createVNode(_Transition, {
      name: "fade",
      onAfterEnter: _cache[5] || (_cache[5] = $event => (_ctx.showModal = true)),
      onAfterLeave: _ctx.afterBackdropLeave
    }, {
      default: _withCtx(() => [
        (_ctx.showBackdrop)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "backdrop",
              onClick: _cache[4] || (_cache[4] = _withModifiers((...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
            }, [
              _createVNode(_Transition, {
                name: "slide-in-top",
                onAfterLeave: _cache[2] || (_cache[2] = $event => (_ctx.showBackdrop = false)),
                onAfterEnter: _cache[3] || (_cache[3] = $event => (_ctx.$emit('on-ready')))
              }, {
                default: _withCtx(() => [
                  (_ctx.showModal)
                    ? (_openBlock(), _createBlock("div", _hoisted_1, [
                        (_ctx.title || _ctx.$slots.header)
                          ? (_openBlock(), _createBlock("div", _hoisted_2, [
                              _createVNode("h3", _hoisted_3, [
                                _renderSlot(_ctx.$slots, "header", {}, () => [
                                  _createTextVNode(_toDisplayString(_ctx.title), 1)
                                ])
                              ]),
                              _createVNode("button", {
                                class: "modal__header-close",
                                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.close && _ctx.close(...args))),
                                "data-tippy-content": "Close modal"
                              }, [
                                _hoisted_4
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_5, [
                          _renderSlot(_ctx.$slots, "default")
                        ]),
                        (_ctx.$slots.footer)
                          ? (_openBlock(), _createBlock("div", _hoisted_6, [
                              _renderSlot(_ctx.$slots, "footer")
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 3
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onAfterLeave"])
  ]))
}

  /**
   * BaseModal component props.
   * @typedef {Object} BaseModalProps
   * @property {string} [title] Modal title | Overridden by header slot
   */

  /**
   * BaseModal component data.
   * @typedef {Object} BaseModalData
   * @property {boolean} showBackdrop Whether to begin rendering the backdrop
   * @property {boolean} showModal Whether to begin rendering the modal
   */

  export default {
    name: "base-modal",
    /**
     * @type BaseModalProps
     */
    props: {
      title: {
        type: String,
        default: "",
      },
    },
    emits: [
      // When modal closes
      "on-close",
      // After modal is animated into view
      "on-ready",
    ],
    /**
     * @returns {BaseModalData}
     */
    data() {
      return {
        showBackdrop: false,
        showModal: false,
      }
    },
    methods: {
      /**
       * Closes this modal.
       */
      close() {
        this.showModal = false
        this.$emit("on-close")
      },
      /**
       * Opens this modal.
       */
      open() {
        this.showBackdrop = true
        document.body.classList.add("js_backdrop-open")
      },
      /**
       * Does cleanup work after the backdrop is animated out of the screen.
       */
      afterBackdropLeave() {
        document.body.classList.remove("js_backdrop-open")
      },
    },
  }
